import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

export default function PermissionButton({
  children,
  onClick,
  color,
  status,
  type,
  title,
  style,
}) {
  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {
    if (status !== 0) {
      if (type === "Post") {
        if (status === 5 || status >= 20) {
          setDisableButton(true);
        }
      } else if (type === "Draft") {
        if (status >= 10) {
          setDisableButton(true);
        }
      } else if (type === "Cancel") {
        if (status >= 20) {
          setDisableButton(true);
        }
      } else if (
        type === "ManagerApprove" ||
        type === "ManagerReject" ||
        type === "ManagerHold"
      ) {
        if (status !== 22) {
          setDisableButton(true);
        }
      } else if (
        type === "ReviewerReview" ||
        type === "ReviewerRejected" ||
        type === "ReviewerHold"
      ) {
        if (status === 22 || status === 24 || status === 26) {
          setDisableButton(true);
        }
      }
    } else {
      setDisableButton(true);
    }
    return () => {};
  }, [status, type]);

  return (
    <Button
      variant="contained"
      onClick={onClick}
      color={color}
      disabled={disableButton}
      style={style}
    >
      {children}
      {title}
    </Button>
  );
}

PermissionButton.defaultProps = {
  status: 0,
};

PermissionButton.propTypes = {
  status: PropTypes.number,
};
